import React from 'react';
import { useReleaseOptions } from '../../../contexts/ReleaseOptionsContext';
import ProductSelector from './ProductSelector';
import VersionSelector from './VersionSelector';
import LanguageSelector from './LanguageSelector';

export default function ReleaseSelectors() {
    const {
        availableProducts, availableVersions, availableLanguages,
        selectedRelease, setSelectedRelease,
    } = useReleaseOptions();
    const selection = { selectedRelease, setSelectedRelease };

    return (
        <>
            <ProductSelector options={availableProducts} {...selection} />
            <VersionSelector options={availableVersions} {...selection} />
            <LanguageSelector options={availableLanguages} {...selection} />
        </>
    );
}
